import { UserService } from 'src/app/services/user.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { BasicProfileRouteData } from './basic-profile/basic-profile.domain';
import { UserRoles } from '../constants/app.constants';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss'],
})
export class RegistrationComponent implements OnInit {
  public enabled: boolean = true;
  public routeData: BasicProfileRouteData;
  isGuest: boolean;

  constructor(private route: ActivatedRoute, private userService: UserService) {}

  ngOnInit(): void {
    this.routeData = this.route.snapshot.data as BasicProfileRouteData;
    this.isGuest = this.userService.getUserRole()?.toLowerCase() === UserRoles.guestTechnician;
  }
}
